import { Component, OnInit, ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { NgForm, FormGroup, FormControl } from '@angular/forms';
import { Globals } from '../globals';
import { ActivatedRoute, Params } from '@angular/router';
import { KycResultsAPIRes, KycResultsAPIReq } from 'src/app/kyc-link-results/kyc-link-results.model';
import { KycLinkResultsService } from 'src/app/kyc-link-results/kyc-link-results.service';

@Component({
  selector: 'app-kyc-link-results',
  templateUrl: './kyc-link-results.component.html',
  styleUrls: ['./kyc-link-results.component.css']
})
export class KycLinkResultsComponent implements OnInit {

  @ViewChild('kycDetailsForm') kycDetailsForm: any;
  showValidationMsgs: boolean = false;
  isLoading: boolean = false;
  uniqueId: string;
  status: string;
  kycResultsAPIReq: KycResultsAPIReq;
  kycResultsAPIRes: KycResultsAPIRes;
  maskEmail: string;
  maskMobile: string;
  dataLoaded: boolean = false;

  constructor(private route: ActivatedRoute, public globals: Globals, public kycLinkResultsService: KycLinkResultsService) {
    this.kycResultsAPIReq = new KycResultsAPIReq();
    this.kycResultsAPIRes = new KycResultsAPIRes();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.uniqueId = params["uniqueId"];
        this.status = params["status"];
        if(this.uniqueId != null && this.uniqueId != '' && this.uniqueId != undefined) {
          this.kycResultsAPIReq.uniqueId = this.uniqueId;
        } if(this.status != null && this.status != '' && this.status != undefined) {
          this.kycResultsAPIReq.status = this.status;
        }
        this.kycResultDetails();
      }
    );
  }

  kycResultDetails() {
    this.isLoading = true;
    this.kycLinkResultsService.kycResultDetails(this.kycResultsAPIReq).subscribe((data: any) => {
      this.isLoading = false;
      this.kycResultsAPIRes = JSON.parse(JSON.stringify(data));
      this.dataLoaded = true;
      if(this.kycResultsAPIRes != null) {
        this.kycResultsAPIRes.uniqueId = this.uniqueId;
        this.maskEmail = this.maskEmailFunc(this.kycResultsAPIRes.email);
        this.maskMobile = this.maskMobileFunc(this.kycResultsAPIRes.mobile);
      }
      if(this.kycResultsAPIRes.returnURL != '' && this.kycResultsAPIRes.returnURL != null && this.kycResultsAPIRes.returnURL != undefined) {
        setTimeout(() => {
          this.goToBackPage();
        }, 3000);
      }
    });
  }

  /*GoToBackPage() {
    this.isLoading = true;
    var form = document.createElement("form");

    form.method = "POST";
    form.action = this.kycResultsAPIRes.returnURL;  

    document.body.appendChild(form);
    form.submit();
  }*/

  goToBackPage() {
    this.isLoading = true;
    window.location.href = this.kycResultsAPIRes.returnURL;
  }

  maskMobileFunc(value) {
    var mobile = "";
    if (value) {
      var mLength = value.length - 2;
      for (let i = 0; i < value.length; i++) {
        if (i < mLength && i > 1) {
          mobile = mobile + "X";
        } else {
          mobile = mobile + value.charAt(i);
        }
      }
    }
    return mobile;
  }

  maskEmailFunc(value) {
    var email = "";
    if (value) {
      var tempEmail = value.split("@")[0];
      for (let i = 0; i < tempEmail.length; i++) {
        if (i < 2 || i > tempEmail.length - 3) {
          email = email + tempEmail.charAt(i);
        } else {
          email = email + "X";
        }
      }
      email = email + "@" + value.split("@")[1];
    }
    return email;
  }
}